import { COOKIE_CONSENT_ROOT_SELECTOR } from "constants/cookieConsentConfig";
import { DialogInteractOutsideHandler } from "types/ui/muggleTestV0/DialogInteractOutsideHandler";

/**
 * Wraps a dialog's outside-interaction handler so answering the cookie consent banner never dismisses the
 * dialog. The caller's own handler still runs first.
 * @param onInteractOutside - The dialog caller's handler, if any.
 * @returns The handler to pass to the Radix dialog content.
 */
export const keepOpenOnCookieConsentInteraction =
  (onInteractOutside?: DialogInteractOutsideHandler): DialogInteractOutsideHandler =>
  (event) => {
    onInteractOutside?.(event);
    if (event.target instanceof Element && event.target.closest(COOKIE_CONSENT_ROOT_SELECTOR)) {
      event.preventDefault();
    }
  };
